import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { CommonButtonRowWidget } from "@eforall/common";
import { DialogService } from "@eforall/dashboard";
import { AccApplicationStatusId } from "@interfaces";
import { FuncService } from "../../../../../services";
import { AccApplicationDialogDataService } from "../../acc-application-dialog-data.service";

@Component({
	selector: 'acc-application-application-seat-part',
	standalone: true,
	imports: [
		CommonButtonRowWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './application-seat.part.html'
})
export class ApplicationSeatPart {

	private dialogDataService = inject(AccApplicationDialogDataService);
	private func = inject(FuncService);

	private dialogService = inject(DialogService);


	public details = computed(() => {
		const data = this.dialogDataService.dialogData();
		if (!data) return;

		const offeredAcc = data.accelerators.find(ta => ta.accId === data.details.offeredSeatAccId);

		let accSeatStatus = 'No Seat Offered';
		if (data.details.offeredSeatAccId) {
			if (data.details.accApplicationStatusId === AccApplicationStatusId.SeatOffered) {
				accSeatStatus = `Seat Offered`;
			} else if (data.details.accApplicationStatusId === AccApplicationStatusId.SeatAccepted) {
				accSeatStatus = 'Seat Accepted';
			} else if (data.details.accApplicationStatusId === AccApplicationStatusId.InCohort) {
				accSeatStatus = 'In Cohort';
			}

			if (offeredAcc) {
				accSeatStatus += ` ( ${offeredAcc.name} : ${this.dialogDataService.app.getStaffNameById(offeredAcc.facilitatorStaffId)} )`;
			}
		}

		return {
			accSeatStatus,
			canSeatBeRevoked: data.details.offeredSeatAccId && data.details.accApplicationStatusId !== AccApplicationStatusId.InCohort,
		}
	});


	async revokeSeat() {
		// Show confirmation dialog
		const yes = await this.dialogService.confirm('Are you sure you want to revoke the offered seat for this application?', 'Yes, Revoke Seat', 'No', [], 400, 200);

		// revoke seat if confirmed
		if (yes) {
			const accApplicationId = this.dialogDataService.dialogData()!.details.accApplicationId; // Non-null assertion as button is only shown when data is present

			const result = await this.func.accApplication.revokeAccSeat({ accApplicationId });

			if (!result.success) {
				await this.dialogService.showMessage('Error', `Failed to revoke seat : ${result.error}`);
				return;
			}

			await this.dialogDataService.reloadData();
		}
	}


}
